/** Hidden form-item suffixes emitted by CustomField for `fieldType: "address"`.
 *  Serialization places the row index between the base and suffix so repeats
 *  mode emits `<base>__<index>__<suffix>` (v1 layout). Any other composite
 *  suffix would be treated as non-composite and reconstructed as
 *  `<base>__<suffix>__<index>`, which would silently drop data on reload.
 *  Keep this list in sync with the `*KeySuffix` constants in
 *  components/CustomField/CustomField.tsx. */
export const ADDRESS_SUBKEY_SUFFIXES = [
  "address",
  "apartment",
  "city",
  "state",
  "zip",
] as const;

/** Set view for `.has()` lookups against a dynamic suffix. */
export const ADDRESS_SUBKEY_SUFFIX_SET: ReadonlySet<string> = new Set(
  ADDRESS_SUBKEY_SUFFIXES
);
